/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCellLeftBorderline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g clipRule="evenodd" fill="currentcolor" fillRule="evenodd">
        <path d="M22 22h-3v-2h1v-1h2zm0-20h-3v2h1v1h2zm0 11h-2v4h2zm0-6h-2v4h2zM2 22h3v-2H4v-1H2zM2 2h3v2H4v1H2zm2 11H2v4h2zm7 9v-2H7v2zm0-18V2H7v2zM4 7H2v4h2zm13 15v-2h-4v2zm0-18V2h-4v2z" />
        <path d="M2 20V4h2v16z" />
      </g>
    </g>
  </Icon>
);
export { SvgCellLeftBorderline as CellLeftBorderline };
